import { useState } from "react";
import { ArrowRight } from "lucide-react";

export const NewsletterBar = () => {
  const [done, setDone] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    setDone(true);
  };
  return (
    <div className="bg-[#004778] px-6 py-2.5" data-testid="newsletter-topbar">
      {done ? (
        <p className="py-1 text-center text-xs font-semibold tracking-wide text-[#C9DA2D]" role="status" data-testid="topbar-newsletter-thanks">
          Thank you for signing up. Mockup note: production connects to HARC's existing Mailchimp list.
        </p>
      ) : (
        <form
          onSubmit={submit}
          className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-2"
          data-testid="topbar-newsletter-form"
        >
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-white">
            Stay connected to HARC
          </p>
          <label htmlFor="topbar-email" className="sr-only">
            Email address
          </label>
          <input
            id="topbar-email"
            type="email"
            required
            placeholder="Email address"
            data-testid="topbar-newsletter-email"
            className="w-56 border border-white/40 bg-transparent px-3 py-1.5 text-xs text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-[#C9DA2D]"
          />
          <button
            type="submit"
            data-testid="topbar-newsletter-submit"
            className="inline-flex items-center gap-1.5 rounded-full bg-[#C9DA2D] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-[#022A42] transition-colors hover:bg-[#FFA100]"
          >
            Sign Up <ArrowRight size={12} aria-hidden="true" />
          </button>
        </form>
      )}
    </div>
  );
};
